import { useTranslation } from 'react-i18next';
import { Alert, Box, Button, Chip, Typography } from '@mui/material';
import Copyable from '@/components/Copyable/Copyable';
import CpdLabeledValue from '@/components/ui/CpdLabeledValue';

const T = 'organizations.update.wellsFargoWebhook';
const DETAIL_SX = { mb: 2 };
const SYNC_BUTTON_SX = { color: 'common.white' };

const STATUS_COLORS = {
  ACTIVE: 'success',
  PENDING: 'warning',
  PAUSED: 'default',
  REJECTED: 'error',
  SUSPENDED: 'error',
};

const SubscriptionDetail = ({ label, children }) => (
  <Box sx={DETAIL_SX}>
    <Typography variant='caption' color='text.secondary'>
      {label}
    </Typography>
    {children}
  </Box>
);

const WellsFargoWebhookSubscriptionDetails = ({
  subscription,
  disabled,
  syncing,
  deleting,
  onSync,
  onDelete,
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      <SubscriptionDetail label={t(`${T}.urlLabel`)}>
        <Copyable value={subscription.url}>
          <Typography sx={{ wordBreak: 'break-all' }}>
            {subscription.url}
          </Typography>
        </Copyable>
      </SubscriptionDetail>
      <CpdLabeledValue
        label={t(`${T}.webhookIdLabel`)}
        value={subscription.webhook_id}
        sx={DETAIL_SX}
      />
      <SubscriptionDetail label={t(`${T}.statusLabel`)}>
        <Box>
          <Chip
            size='small'
            label={subscription.status}
            color={STATUS_COLORS[subscription.status] ?? 'default'}
          />
        </Box>
      </SubscriptionDetail>
      <Alert severity='info'>{t(`${T}.validationNote`)}</Alert>
      <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
        <Button
          variant='contained'
          color='primary'
          onClick={onSync}
          disabled={disabled}
          sx={SYNC_BUTTON_SX}>
          {syncing && t(`${T}.syncing`)}
          {!syncing && t(`${T}.syncButton`)}
        </Button>
        <Button
          variant='outlined'
          color='error'
          onClick={onDelete}
          disabled={disabled}>
          {deleting && t(`${T}.deleting`)}
          {!deleting && t(`${T}.deleteButton`)}
        </Button>
      </Box>
    </Box>
  );
};

export default WellsFargoWebhookSubscriptionDetails;
